import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[580px] md:h-[680px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20fantasy%20anime%20style%20mysterious%20floating%20island%20surrounded%20by%20magical%20aurora%20and%20cherry%20blossom%20petals%2C%20soft%20pastel%20pink%20and%20mint%20green%20color%20palette%2C%20dreamy%20atmosphere%20with%20floating%20crystals%20and%20gentle%20light%20beams%2C%20ethereal%20clouds%2C%20enchanting%20fantasy%20world%20with%20distant%20castles%20and%20sparkling%20stars%2C%20illustration%20style%2C%20high%20detail%2C%20soft%20lighting&width=1800&height=800&seq=hero-rebirth-island&orientation=landscape"
        alt="重生萝莉岛 - 神秘奇幻岛屿"
        title="重生萝莉岛——全新冒险等你开启"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
      <div className="relative z-10 w-full text-center px-4 md:px-6">
        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl text-white mb-6 drop-shadow-lg">
          重生萝莉岛
        </h1>
        <p className="text-lg md:text-xl text-white/90 max-w-2xl mx-auto mb-8 leading-relaxed drop-shadow-md">
          融合萌系角色与奇幻剧情，带你体验全新世界的惊喜与成长。
          探索重生萝莉岛的独特魅力，感受每一次重生带来的无限可能与热血剧情。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/gonglue"
            className="px-8 py-3 bg-primary-500 text-white rounded-full font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-book-open-line mr-2"></i>
            开始冒险
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 bg-white/20 backdrop-blur-sm text-white rounded-full font-medium text-sm hover:bg-white/30 transition-colors whitespace-nowrap cursor-pointer border border-white/30"
          >
            <i className="ri-information-line mr-2"></i>
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}